'use client'

import { AddIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Card,
  Flex,
  Heading,
  Image,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import DataNotFound from "common/components/notFoundData";
import AddDocumentModal from "services/Crm/utils/addDocumentModal";
import "common/assets/css/viewEdit.css";
import DateFormatter from "common/utils/dateFormater";
import { crmConstant } from "services/Crm/constant";
import { globalStyles } from "common/theme/styles";
import { formatFileSize } from "services/Crm/utils/calcUtils";
import zipIcon from "../../../../auth/assets/img/zipIcon.png";
import pdfIcon from "../../../../auth/assets/img/pdfIcon.png";
import imageIcon from "../../../../auth/assets/img/imageIcon.png";
import deleteIcon from "common/assets/img/deleteIcon.png";
import { constant } from "common/constant";
import { deleteApi } from "common/services/api";
import CommonDeleteModel from "common/components/commonDeleteModel";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Attachment = (props) => {
  const param = useParams();
  const [deleteModel, setDeleteModal] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);

  const {
    setAddDocument,
    textColor,
    download,
    addDocument,
    setAction,
    allData,
    component,
    fetchNewData,
  } = props;

  const handleDelete = async (fileId) => {
    try {
      const finalUrl = `api/document/delete/`;
      const response = await deleteApi(finalUrl, fileId);

      if (response && response.status === 200) {
        if (fetchNewData) {
          if (
            component === crmConstant.accounts ||
            component === crmConstant.deals
          ) {
            fetchNewData(null, false);
          } else {
            fetchNewData(false);
          }
        }
        toast.success(crmConstant.attachmentDeletedSuccessfully);
      } else {
        toast.error(crmConstant.someThingWentWrong);
      }
    } catch (e) {
      toast.error(crmConstant.someThingWentWrong);
    } finally {
      closeDeleteModal();
    }
  };

  function closeDeleteModal() {
    setDeleteModal(false);
  }
  
   useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);

  return (
    <>
      <Card className="viewEditAttachmentCard" minH="50vh">
        <Flex
          className="viewEditAttachmentHeader-container"
          alignItems="center"
          justifyContent="space-between"
        >
          <Heading className="viewEditAccordianHeader" size="md">
            {crmConstant.attachment}
          </Heading>
          <Button
            leftIcon={<AddIcon me={"0"} fontSize={"12px"} />}
            size="sm"
            className="viewEditBtn attachBtn accordianAddBtn"
            onClick={() => setAddDocument(true)}
          >
            {crmConstant.attachment}
          </Button>
        </Flex>

        <VStack
          className="viewEditAttachmentBody"
          p="16px"
          alignItems="flex-start"
        >
            <Table
              variant="simple"
              color="gray.500"
              className="lead-table-main"
            >
              <Thead>
                <Tr>
                  <Th color={globalStyles.colors.textColor}>
                    {crmConstant.fileName}
                  </Th>
                  <Th color={globalStyles.colors.textColor}>
                    {crmConstant.attachedBy}
                  </Th>
                  <Th color={globalStyles.colors.textColor}>
                    {crmConstant.createdAt}
                  </Th>
                  <Th color={globalStyles.colors.textColor}>File Type</Th>
                  <Th color={globalStyles.colors.textColor}>
                    {crmConstant.size}
                  </Th>
                  <Th color={globalStyles.colors.textColor}>
                    {crmConstant.action}
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {(allData?.Document?.length || allData?.documents?.length) > 0 ? (
                  (allData?.Document || allData?.documents)?.flatMap((item) =>
                    item?.files?.map((file, index) => {
                      return (
                        <Tr key={index}>
                          <Td
                            onClick={() => download(file._id)}
                            color={globalStyles.colors.cta["100"]}
                            cursor="pointer"
                          >
                            <Text>{file.fileName}</Text>
                          </Td>
                          <Td color={globalStyles.colors.text["200"]}>
                            <Text>{item.createByName || "-"}</Text>
                          </Td>
                          <Td color={globalStyles.colors.text["200"]}>
                            <Text>
                              {file.createOn ? DateFormatter(file.createOn) : "-"}
                            </Text>
                          </Td>
                          <Td color={globalStyles.colors.text["200"]}>
                            <Box
                              display={"flex"}
                              gap={"8px"}
                              alignItems={"center"}
                              position={"relative"}
                            >
                              {(() => {
                                const path = item.files?.[index]?.path;
                                if (!path) return "-";

                                const ext = path.split(".").pop().toLowerCase();

                                let icon = null;
                                if (ext === "zip") icon = zipIcon;
                                else if (ext === "pdf") icon = pdfIcon;
                                else if (["jpg", "jpeg", "png"].includes(ext))
                                  icon = imageIcon;

                                return (
                                  <Box className="toolTipBox">
                                    {icon && (
                                      <Image src={icon} height={"28px"} width={"28px"} />
                                    )}
                                    <Text className="toolTip">{ext}</Text>
                                  </Box>
                                );
                              })()}
                            </Box>
                          </Td>
                          <Td color={globalStyles.colors.text["200"]}>
                            <Text>
                              {file?.fileSize ? formatFileSize(file.fileSize) : "-"}
                            </Text>
                          </Td>
                          <Td>
                            <Box w={"24px"} className="toolTipBox">
                              <Image
                                onClick={() => {
                                  setDeleteModal(true);
                                  setSelectedValues([file?._id]);
                                }}
                                src={deleteIcon}
                                h={"20px"}
                                w={"20px"}
                              />
                              <Text className="toolTip">{constant.delete}</Text>
                            </Box>
                          </Td>
                        </Tr>
                      );
                    })
                  )
                ) : (
                  <Tr>
                    <Td colSpan={6} className="nodataTd">
                        <DataNotFound title={crmConstant.attachments} />
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
        </VStack>
      </Card>

      <AddDocumentModal
        addDocument={addDocument}
        setAddDocument={setAddDocument}
        linkId={param.id}
        from={component}
        setAction={setAction}
        fetchNewData={fetchNewData}
      />
      {deleteModel && (
        <CommonDeleteModel
          isOpen={deleteModel}
          notCheckbox={true}
          onClose={() => closeDeleteModal()}
          type={
            constant.attachment
          }
          handleDeleteData={handleDelete}
          ids={selectedValues}
        />
      )}
    </>
  );
};

export default Attachment;
